import React, { useState } from "react";
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure, Input} from "@nextui-org/react";
import { RxUpdate } from "react-icons/rx";
import axios from "axios";
import { toast } from "react-toastify";
import { FiEdit } from "react-icons/fi";
import { orders_uri } from "../../../utils/url";

export default function UpdateModal({data, callback}) {
  const {isOpen, onOpen, onOpenChange} = useDisclosure();
  const [pay, setPay] = useState();
  const [load, setLoad] = useState(false);

  const [phone, setPhone] = useState(data.phone_or_depo);
  const [too, setToo] = useState(data.too);
  const [code, setCode] = useState(data.code);
  const [prod, setProd] = useState([]);

  const call = () =>{
    callback();
  }

  const Sub = async () =>{
    setLoad(true);
    try{
        const res = await axios.patch(orders_uri+'/update', {id: data.id, phone_or_depo: phone, code:code, too:too});
        if(res.status === 200){
            toast.success("Амжилттай");
            setPay('');
            call();
            setLoad(false);
            onOpenChange(false);
        }
    }catch(err){
        console.log(err);
        setLoad(false);
    }
  }

  const Get = async () =>{
    setLoad(true);
    try{
        const res = await axios.get(orders_uri+`/code?id=${data.product.id}`);
        setProd(res.data)
        setLoad(false);
    }catch(err){
        console.log(err);
        setLoad(false);
    }
  }

  function haha(){
    onOpen();
    Get();
  }



  return (
    <>
      <FiEdit  onClick={haha} className="bg-gray-400 rounded-full p-1 cursor-pointer" color="white" size={24}/>
      <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">Захиалга засварлах</ModalHeader>
              <ModalBody>
                <div className="font-Roboto">
                    <h1 className="text-sm font-bold">Захиалгын утас эсвэл данс *</h1>
                    <Input className="mt-2" size="sm" value={phone} onChange={(e)=> setPhone(e.target.value)}/>

                    <h1 className="text-sm font-bold mt-3">Захиалгын тоо *</h1>
                    <Input className="mt-2" size="sm" value={too} onChange={(e)=> setToo(e.target.value)}/>

                    <h1 className="text-sm font-bold mt-3">Захиалгын код *</h1>
                    <select className="bg-gray-100 rounded-md p-1 mb-4 w-full" onChange={(e)=> setCode(e.target.value)}>
                      <option value='undefined'>Одоо байгаа ({code})</option>
                      {
                        prod.map((it, index) => {
                          return(
                            <option value={it.code} key={index}>{it.code}</option>
                          )
                        })
                      }
                    </select>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="light" onPress={onClose}>
                  Close
                </Button>
                {
                    load?
                    <Button className="bg-blue-300">
                        Уншиж байна ...
                    </Button>
                    :
                    <Button color="primary" onPress={Sub}>
                        Тийм
                    </Button>
                }
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
